import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 44"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { transform: "scale(.26458)" }, [
      _createElementVNode("circle", {
        cx: "83.15",
        cy: "83.15",
        r: "83.15",
        fill: "#07f",
        "fill-rule": "evenodd"
      }),
      _createElementVNode("path", {
        fill: "#fff",
        d: "M89.239 119.901c-37.497 0-60.254-26.016-61.138-69.247h18.99c.593 31.757 15.041 45.234 26.117 47.98v-47.98h18.206v27.4c10.683-1.185 21.859-13.65 25.623-27.4h17.9c-2.866 16.916-15.033 29.382-23.64 34.524 8.607 4.157 22.457 15.04 27.798 34.723h-19.683c-4.157-13.158-14.348-23.348-27.998-24.732V119.9z"
      })
    ], -1)
  ]))]))
}
export default { render: render }